import { Application } from '@hotwired/stimulus';

// Import controllers that don't follow the *_controller.js naming convention
import TosNavigation from './tos_navigation';

// Custom name mappings for controllers that need specific registration names
const customMappings = {
  form_add_property_controller: 'add-property-form',
  guests_controller_experience: 'guests-experience',
  user_gallery_controller: 'user-images',
};

// Manually register non-standard controllers
const manualControllers = {
  'scroll-spy': TosNavigation,
};

function getControllerName(filename) {
  // Remove ./ prefix and file extension
  const baseName = filename
    .replace(/^\.\//, '')
    .replace(/\.(js|ts)$/, '')
    .replace(/_controller$/, '');

  // Check for custom mapping
  const fullName = filename.replace(/^\.\//, '').replace(/\.(js|ts)$/, '');
  if (customMappings[fullName]) {
    return customMappings[fullName];
  }

  const controllerName = fullName.replace(/_controller$/, '');
  if (customMappings[controllerName]) {
    return customMappings[controllerName];
  }

  // Convert snake_case to kebab-case
  return baseName.replace(/_/g, '-');
}

function registerControllers() {
  const application = Application.start();

  // Make Stimulus available globally for debugging
  window.Stimulus = application;

  // Auto-register all *_controller.{js,ts} files using webpack's require.context
  const controllerContext = require.context('./', false, /_controller\.(js|ts)$/);

  controllerContext.keys().forEach((filename) => {
    const module = controllerContext(filename);
    const name = getControllerName(filename);
    application.register(name, module.default);
  });

  // Register manually imported controllers
  Object.entries(manualControllers).forEach(([name, controller]) => {
    application.register(name, controller);
  });

  return application;
}

// Wait for DOM to be ready
const ready = (callback) => {
  if (document.readyState !== 'loading') callback();
  else document.addEventListener('DOMContentLoaded', callback);
};

ready(() => {
  registerControllers();
});

export default registerControllers;
